<template>
  <div class="page-headline">
    <div class="page-headline-contents">
      <PageHeadlineTitle :title="title" class="page-headline__title" />
      <span class="page-headline__link" @click="onClickLink">{{
        linkTitle
      }}</span>
    </div>
  </div>
</template>
<script>
import PageHeadlineTitle from '../../atoms/headlines/PageHeadlineTitle.vue'
export default {
  components: { PageHeadlineTitle },
  props: {
    title: {
      type: String,
      required: true
    },
    linkTitle: {
      type: String,
      required: true
    }
  },
  methods: {
    onClickLink() {
      this.$emit('click-link')
    }
  }
}
</script>
<style lang="scss" scoped>
.page-headline {
  background-color: $white;
  text-align: left;
  padding: 24px 16px;

  &-contents {
    margin: auto;
    max-width: $max-contents-width;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__link {
    @extend %hover-common;
    color: $link;
    font-size: 1.4rem;
    cursor: pointer;

    @media all and (max-width: $base-contents-width) {
      font-size: 1.2rem;
    }
  }

  @media all and (max-width: $sp-iphone5-width) {
    &__title {
      font-size: 1.6rem;
    }
  }
}
</style>
